import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center space-y-6 max-w-md">
        {/* <h1 className="text-6xl font-bold text-gray-900">404</h1> */}
        <h2 className="text-2xl font-semibold text-gray-700">
          Pagina niet gevonden
        </h2>
        <p className="text-gray-500">
          Sorry, we kunnen de pagina die je zoekt niet vinden. Misschien is deze
          verplaatst of verwijderd.
        </p>
        <br />
        <Link to="/">
          <Button className="bg-green-600 hover:bg-green-700">
            Terug naar Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
